import BaseService from "@/boot/BaseService";
class CodigoService extends BaseService {
  constructor() {
    super(null, "/codigo");
  }
  async variablesByType(type) {
    return await this.get("/variables-by-type", { type });
  }
  async variables() {
    return await this.get("/variables");
  }

  async decodificar(codigo) {
    return await this.get("/decodificar", { codigo });
  }

  async posiciones() {
    return await this.get("/posiciones");
  }
}

export default new CodigoService();
